import { Container, Flex, Box, Heading, Text, Button } from "@chakra-ui/react";
import Image from 'next/image';
import Head from "next/head";
import { useRouter } from "next/router";

const Error403 = () => {
  const { push } = useRouter();

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Packs | 403</title>
        <meta name="description" content="Collect and curate everything on a subject. Add context to each file. Pack it all up in one master link. Then email the link, share it on Slack, pass it around your team. And put an end to losing + explaining assets" />
      </Head>
      <Container maxWidth={920} width="100%" padding={0} margin={'0 auto'}>
        <Flex align="center" width="100%" direction="column" className="pack__509-container">
          <Box>
            <Image src="/403.png" width={575} height={273} alt="403 forbidden"  />
          </Box>
          <Box>
            <Heading color="error.500">Forbidden</Heading>
          </Box>
          <Box>
            <Text>
              We&apos;re sorry, but you do not have permission to access this page.
            </Text>
          </Box>
          <Box>
            <Button variant="secondary" onClick={() => push('/login')}>Back to Packs</Button>
          </Box>
        </Flex>
      </Container>
    </>
  )
}

export default Error403;
